<template>
 
      <div id="echart-line" style="width: 100%;height: 90%; margin-top: 3.5rem;"></div>

</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionRealTime",
  controller: "UI",
  action: "OpinionRealTime",
  data() {
      return {
      loading: false,
      loadingText: '加载中...',
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
       let that = this;
       let searchInfo = {
        BeginTime: new Date(new Date().getFullYear()+"-01"+"-01"),
        EndTime: new Date(),
      };
       new MyApis.OpinionApi()
        .GetTodayReport(searchInfo)
        .then((r) => {
          r = r.data.Data;
         
          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });

    },
    drawChart(data) {
      if(data)
      {
         var legendData = [];
         var seriesData = [];
         var xAxis=data.ChartTrendGood.XData;
           
         var linegooddata=  data.ChartTrendGood.SeriesData1[0];
         var linebaddata=data.ChartTrendBad.SeriesData1[0];

         legendData.push(linegooddata.name);
         legendData.push(linebaddata.name);
         seriesData.push({name:linegooddata.name,type:"line",smooth:true,data:linegooddata.data})
         seriesData.push({name:linebaddata.name,type:"line",smooth:true,data:linebaddata.data})
        console.log(seriesData);
        // eslint-disable-next-line no-undef
        var myChart = echarts.init(document.getElementById('echart-line'));
        var echartsColor = ["#2ac1ff","#e6a23c","#f56c6c","#67c23a","#cf9236","#257dd4","#91c7ae"]
         // eslint-disable-next-line no-undef
         var colors = echartsColor.slice(parseInt(Math.random() * echartsColor.length / 2));
        myChart.setOption({
           color:colors,
           title: {
                show: false
            },
            tooltip: {
                trigger: 'axis'
            },
          legend:{
             x: 'center',
             y: 'bottom',
             data: legendData,
             textStyle:{ color:'#fff'}
          },
           toolbox: {
                show: true ,             
            },
            calculable: true,
             xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xAxis,
                axisLabel:{
                  color: '#fff'
                },
                axisLine:{
                  lineStyle:{
                     color:'#fff',
                     width:1,   //这里是坐标轴的宽度,可以去掉
                      }
                }
            },
            yAxis: {
                type: 'value',
                 splitLine: {
                    show: false
                  },
                 axisLabel: {
                    show: true,
                    textStyle: {
                         color: '#fff'
                           }
                   },
                 axisLine:{
                    lineStyle:{
                    color:'#fff',
                    width:1,                  //这里是坐标轴的宽度
                    }
                  }
            },
           series:seriesData
        })
      }     
     }
  }
}

</script>